import { ACTION_COLUMN_ID } from '@components-library/Grid/interfaces';

export const isActionsColumn = (columnId: string) => {
  return columnId === ACTION_COLUMN_ID;
};
